/**
 * Pure view-behavior helpers for the voice-intake controller. No DOM access —
 * callers pass measured geometry and timestamps — so the decisions are
 * unit-testable without a browser.
 */

/** Quiet period after a user scroll during which auto-scrolling is suppressed. */
export const USER_SCROLL_QUIET_MS = 4000

export interface RowRect {
  top: number
  bottom: number
}

/**
 * Whether a freshly connected current-question row should be auto-scrolled
 * into view. Two rules, both from the design contract:
 *   - nothing moves under the user's finger: never scroll within
 *     USER_SCROLL_QUIET_MS of the last user scroll (lastUserScrollMs is null
 *     when the user has not scrolled);
 *   - only scroll when the row is not already fully inside the viewport.
 */
export function shouldAutoScroll(
  rowRect: RowRect,
  viewportHeight: number,
  lastUserScrollMs: number | null,
  nowMs: number,
): boolean {
  if (lastUserScrollMs !== null && nowMs - lastUserScrollMs < USER_SCROLL_QUIET_MS) return false
  return rowRect.top < 0 || rowRect.bottom > viewportHeight
}
